import {createAction} from 'redux-actions';
import {
  HOLD_PRODUCT,
  HOLD_PRODUCT_RESET
} from '../config/const';
// - Actions
export const holdProduct = createAction(HOLD_PRODUCT, product => product);
export const resetHoldProduct = createAction(HOLD_PRODUCT_RESET);

// - State
const initialState = null;

// - Reducers

const holdProductReducer = (state = initialState, action) => {
  switch (action.type) {
  case HOLD_PRODUCT:
    return action.payload;
  case HOLD_PRODUCT_RESET:
    return initialState;
  default:
    return state;
  }
};

export default holdProductReducer;



// WEBPACK FOOTER //
// ./src/reducers/holdProductReducer.js